import { Observable, of } from 'rxjs';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

export function canManageUsers(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Can Manage Users',
    description: 'Check if user has permission to manage other users',
    requiresContext: false,
    execute: (context?: any) => {
      
      // Get current user
      const currentUser = service.authService.getCurrentUser();
      if (!currentUser) {
        return of(false);
      }

      // Check if user has management roles
      const managementRoles = ['superadmin', 'orgadmin', 'uddansvarlig'];
      if (currentUser.roles && currentUser.roles.some((role: string) => managementRoles.includes(role))) {
        return of(true);
      }

      return of(false);
    }
  };
} 